export function getElementByKey(spec: any[], keys: string): any {
  let current: any = spec

  // Split keys by dot to get array of key parts
  const keyParts = keys.split('.')

  // console.log("keyParts", keyParts);
  for (let i = 0; i < keyParts.length; i++) {
    const part = keyParts[i]
    const isLastKey = i === keyParts.length - 1 // Periksa apakah ini adalah elemen terakhir

    if (Array.isArray(current)) {
      // Jika current adalah array, gunakan index
      const index = parseInt(part, 10)
      // console.log("index", index);
      if (isNaN(index) || index < 0 || index >= current.length) {
        return null // Key tidak valid
      }
      current = current[index]
    } else if (typeof current === 'object' && current !== null) {
      // Jika current adalah object, cari berdasarkan children
      if (!('children' in current)) {
        return null // Tidak ada children untuk dilanjutkan
      }
      if (Array.isArray(current.children)) {
        current = current.children
        // Continue the loop to process the current part again with the children array
        i-- // Decrement i so we process this part again with the children array
      } else {
        return null // Handle cases where children is not an array
      }
    } else {
      return null // Key tidak valid
    }

    // Handler untuk lastKey
    if (isLastKey) {
      // console.log("Last key reached:", current);
      // Tambahkan logika tambahan di sini jika diperlukan
    }

    // console.log("current", current);
  }

  return current
}
